module.exports = __webpack_public_path__ + "img/user05.795327fc.png";